import React, { useState } from "react";
import { Calendar } from "primereact/calendar";

const DatePicker = ({
  date = null,
  onChange = () => {},
  placeholder = "YYYY-MM-DD",
}) => {
  const parsedDate = date ? new Date(date) : null;

  return (
    <div>
      <Calendar
        value={parsedDate}
        onChange={onChange}
        showButtonBar
        placeholder={placeholder}
      />
    </div>
  );
};

export default DatePicker;
